import { useEffect } from 'react';

/**
 * Observes an element using ResizeObserver.
 * Memoize `options` and `observerCallback` if they are defined in a component body.
 */
export const useResizeObserver = (
  element: Element | null,
  options: ResizeObserverOptions | undefined,
  observerCallback: ResizeObserverCallback,
): void => {
  useEffect(() => {
    if (!element || !('ResizeObserver' in window)) {
      return undefined;
    }

    const observer = new ResizeObserver(observerCallback);

    observer.observe(element, options);

    return () => {
      observer.disconnect();
    };
  }, [element, options, observerCallback]);
};
